import { useReducer } from "react";

export function useToggle(initial: boolean): [boolean, () => void] {
    return useReducer((b: boolean) => !b, initial) as [boolean, () => void];
}
